import { useRef, createRef, useState, useEffect } from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import RadioQuestion from "../../components/profileOrganization/RadioQuestion";
import InputRadio from "../../components/profileOrganization/InputRadio";
import OrganizationNameQuestion from "../../components/profileOrganization/OrganizationNameQuestion";
import CardQuestion from "../../components/profileOrganization/CardQuestion";
import LinearSliderQuestion from "../../components/profileOrganization/LinearSliderQuestion";
import SelectCountry from "../../components/profileOrganization/SelectCountry";
import MultiTags from "../../components/profileOrganization/MultiCheckboxesTags";
import NonLinear from "../../components/profileOrganization/NonLinear";
import { globalData } from "./data";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import MultiSelect from "../../components/profileOrganization/MultiSelect";
import MultiSelectInput from "../../components/profileOrganization/CheckboxInputs";
import {
  requestCreatingOrganizationProfile,
  requestUpdatingOrganizationProfile,
} from "../../redux/actions/organizationProfileCreators";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileNames } from "../../redux/actions/profileNamesActionCreators";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import ConditionalMultiSelect from "../../components/profileOrganization/ConditionalMutliSelect";
import WebAppDate from "../../components/profileOrganization/Date";
import moment from "moment";
import InputField from "../../components/profileOrganization/TextField";
import ControlEditOrgaProfile from "./ControlEditOrgaProfile";
import InputNumberQuestion from "../../components/profileOrganization/InputNumber";

const initialState = {
  name_A: "",
  domaine_A: null,
  model_A: [],
  display_clients_number_A_B2B: 0,
  display_clients_number_A_B2C: 0,
  turnover_A: 0,
  head_office_country_B: "FR",
  externalised_HR_service_B: null,
  number_of_employees_B: 0,
  remote_work_policy_C: null,
  it_department: null,
  it_department_employees_number_B: 1,
  security_team_employees_number_B: 0,
  apps_daily_use_number_C: 0,
  datacenter_C: null,
  datacenter_number_C: 0,
  datacenter_location_C: [],
  system_equipments_C: {},
  cloud_usage_C: null,
  cloud_providers_C: [],
  service_model_C: {},
  service_delivery_D: null,
  Sla_availability_D: null,
  // service_tools: null,
  service_delivery_tools_number_D: 0,
  kpi_presence_D: null,
  kpi_support_method_D: null,
  subcontractors_presence_D: null,
  e_commerce_presence_D: null,
  payment_process_D: null,
  proprety_intellectuel: null,
  intellectual_property_E: [],
  personal_data_E: null,
  personal_data_list_E: [],
  critical_personal_data_list_E: [],
  subcontractors_data_access_E: null,
  organization_data: null,
  software_type: null,
  software_formula: null,
  office_access: null,
  annualized_frequency: {
    ransomware: 0,
    dos: 0,
    supply_chain: 0,
    data_breaches: 0,
    social_engineering: 0,
    no_attack: 0,
    i_dont_know: 0,
  },
  disruption_hours: "",
  disruption_level: null,
  unavailability_cost: null,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const ProfileOrganization = ({ isEdit, steps, jsonData, profileId }) => {
  // const nextQuestionHandler = (option, currentQuestion) => {
  //   setMyAnswer(option)
  //   scrollToQuestion(currentQuestion + 1)
  // };
  const { isAuth } = useSelector((state) => state.user);
  const profiles = useSelector(
    (state) => state.organizationProfile.organizationProfiles
  );
  let history = useHistory();
  const pendingQuizzes = localStorage.getItem("pending_quizzes");
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const accountType = storedUser?.account_type;
  const profileNames = useSelector((state) => state.profileNames.list);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [stockedDataApp, setStockedDataApp] = useState(
    jsonData?.personal_data_list_E?.map((el) =>
      globalData
        .filter((el) => el.key === "personal_data_list_E")[0]
        .choises.find((item) => item.value === el)
    )
  );
  const [showedQuestions, setShowedQuestions] = useState([0]);
  const [minHeight, setMinHeight] = useState(800);
  const [payload, setPayload] = useState(isEdit ? jsonData : initialState);
  const [forEdit, setForEdit] = useState(payload);
  const [value, setValue] = useState(isEdit ? steps[0] - 1 : 0);
  const [error, setError] = useState(true);
  const [selectedOrga, setSelectedOrga] = useState({});
  const [open, setOpen] = useState(false);
  const [requiredQuestion, setRequiredQuestion] = useState(false);

  const myRefs = useRef([]);
  const [latestQuestion, setLatestQuestion] = useState(
    Math.max(...globalData.map((el) => el.id))
  );
  const [latestStepQuestion, setLatestStepQuestion] = useState(0);
  myRefs.current = [];
  const dispatch = useDispatch();
  // myRefs.current = data.map((element, i) => myRefs.current[element.id] ?? createRef());
  globalData.forEach((element) => {
    if (!myRefs.current[element.id]) {
      myRefs.current[element.id] = createRef();
    }
  });
  const handleClose = () => {
    setOpen(false);
  };

  const handelRequiredQuestion = (bool) => {
    setRequiredQuestion(bool);
  };

  useEffect(() => {
    dispatch(fetchProfileNames());
  }, [dispatch]);

  useEffect(() => {
    setSelectedOrga(profiles.find((profile) => profile?.id === profileId));
  }, [profiles]);

  useEffect(() => {
    if (isEdit) {
      if (selectedOrga?.tabs_completed !== 7) {
        const asArray = Object.entries(jsonData);
        const filtring = asArray.filter(([key, value]) => {
          const isAllZero = typeof value === 'object' && value !== null &&
            !Array.isArray(value) &&
            Object.values(value).every(val => val === 0);

          const isValueValid =
            value !== null &&
            (value !== 0 || (value === 0 && (key === "unavailability_cost" || key === "Sla_availability_D"))) &&
            (Array.isArray(value) ? value.length !== 0 : true) &&
            (typeof value === "object" ? JSON.stringify(value) !== "{}" : true) &&
            !isAllZero && value !== ""
          const isSpecialKey = [
            "WebApp_status_F",
            "it_department",
            "service_delivery_D",
            "proprety_intellectuel",
            "externalised_HR_service_B",
            "disruption_level"
          ].includes(key);

          return isValueValid || isSpecialKey;
        });


        const filtredJson = Object.fromEntries(filtring);
        const showedStepQuestions = globalData
          .filter(
            (el) =>
              (Object.keys(filtredJson).includes(el.key) ||
                Object.keys(filtredJson).includes(el.keyB2B) ||
                Object.keys(filtredJson).includes(el.keyB2C)) &&
              steps.includes(el.category + 1)
          )
          .map((el) => el.id);
        setShowedQuestions(showedStepQuestions);
        if (
          // (steps[0] === 2 && filtredJson["it_department"] === false) ||
          (steps[0] === 3 && filtredJson["service_delivery_D"] === false) ||
          (steps[0] === 4 && filtredJson["personal_data_E"] === false) ||
          (steps[0] === 5 && filtredJson["annualized_frequency"]?.i_dont_know === 1 || filtredJson["annualized_frequency"]?.no_attack === 1) ||
          (steps[0] === 5 && filtredJson["disruption_hours"])

          // (steps[0] === 6 && filtredJson["e_commerce_presence_D"] === false) 
        ) {
          setLatestStepQuestion(Math.max(...showedStepQuestions));
        }

        setCurrentQuestion(Math.max(...showedStepQuestions));
      } else {
        const asArray = Object.entries(jsonData);
        const filtring = asArray.filter(
          ([key, value]) =>
            (value !== null &&
              // value !== 0 &&
              value.length !== 0 &&
              JSON.stringify(value) !== "{}") ||
            key === "WebApp_status_F"
        );
        const filtredJson = Object.fromEntries(filtring);
        const showedStepQuestions = globalData
          .filter(
            (el) =>
              (Object.keys(filtredJson).includes(el.key) ||
                Object.keys(filtredJson).includes(el.keyB2B) ||
                Object.keys(filtredJson).includes(el.keyB2C)) &&
              steps.includes(el.category + 1)
          )
          .map((el) => el.id);

        setShowedQuestions(showedStepQuestions);
        setLatestStepQuestion(Math.min(...showedStepQuestions));
        setCurrentQuestion(Math.min(...showedStepQuestions));
      }
    }
  }, [isEdit, steps, jsonData, selectedOrga]);

  useEffect(() => {
    if (myRefs?.current[currentQuestion]?.current) {
      myRefs?.current[currentQuestion]?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    if (!isEdit) {
      setValue(globalData.find((el) => el.id === currentQuestion).category);
    }
  }, [currentQuestion, isEdit]);

  const scrollToStep = (id) => {
    myRefs.current[id].current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handlePayload = (data, value) => {
    const genericNextQuestion = isEdit ? "nextStepQuestion" : "nextQuestion";
    if (data.conditional) {
      if (data.key === "software_type") {
        setPayload({
          ...payload,
          software_formula: null,
        });
      }

      if (currentQuestion === data.id) {
        setMinHeight(minHeight + 200);
      }
      const nextQuestion =
        data.key === "software_type" &&
          value !== "microsoft_office" &&
          value !== "google_workspace" &&
          value !== null
          ? data[genericNextQuestion]["other"]
          : data[genericNextQuestion][value];
      if (payload[data.key] !== value) {
        const obj = { ...payload };
        const listRemovedKey = globalData
          .filter((el) => data.id < el.id)
          .map((el) => el.key)
          .filter((el) => el !== undefined);
        listRemovedKey.forEach((item) => delete obj[item]);
        // setPayload({ ...payload, ...obj, [data.key]: value });
        setPayload((prevPayload) => ({
          ...prevPayload,
          ...obj,
          [data.key]: value,
        }));
        if (!nextQuestion) {
          setShowedQuestions([
            ...showedQuestions.filter((el) => data.id >= el),
          ]);
          if (isEdit) {
            setLatestStepQuestion(data.id);
          } else {
            setLatestQuestion(data.id);
          }

          setCurrentQuestion(data.id);

          return;
        } else {
          setShowedQuestions([
            ...showedQuestions.filter(
              (el) => data.id >= el || el >= nextQuestion
            ),
            nextQuestion,
          ]);
          if (nextQuestion === 28 && payload["cloud_usage_C"] === true) {
            setCurrentQuestion(29);
          } else if (
            nextQuestion === 14 &&
            payload["personal_data_E"] === true
          ) {
            setCurrentQuestion(17);
          }
          {
            setCurrentQuestion(nextQuestion);
          }
        }
      } else {
        if (myRefs.current[nextQuestion]?.current !== null) {
          myRefs.current[nextQuestion]?.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          setCurrentQuestion(nextQuestion);
          setShowedQuestions([...showedQuestions, nextQuestion]);
        }
        if (data.id === 28 && payload["cloud_usage_C"] === true) {
          setCurrentQuestion(30);
        }
        if (nextQuestion === 14 && payload["personal_data_E"] === true) {
          setCurrentQuestion(14);
        }
        if (data.id === 46 && payload["e_commerce_presence_D"] === true) {
          setCurrentQuestion(47);
        }

      }
    } else {
      if (data.key && value !== null)
        if (data.key === "WebApp_Launch_Date_F") {
          const today = moment();
          const date = moment(value);
          const age = today.diff(date, "years");
          setPayload({
            ...payload,
            WebApp_Launch_Date_F: value,
            WebApp_age_F: age,
          });
        } else {
          setPayload({ ...payload, [data.key]: value });
        }
    }
  };

  const handlePayloadB2B = (data, value) => {
    if (data.keyB2B && value !== null) {
      const numericValue = Number(value);
      setPayload({ ...payload, [data.keyB2B]: numericValue });
    }
  };

  const handlePayloadB2C = (data, value) => {
    if (data.keyB2C && value !== null) {
      const numericValue = Number(value);
      setPayload({ ...payload, [data.keyB2C]: numericValue });
    }
  };

  useEffect(() => {
    if (isEdit) {
      if (payload.it_department === null || payload.it_department === false) {
        setForEdit({
          ...payload,
          it_department_employees_number_B: null,
          // security_team: null,
          security_team_employees_number_B: null,
        });
      } else {
        setForEdit({
          ...payload,
          it_department_employees_number_B:
            payload.it_department_employees_number_B,
          // security_team: null,
          // security_team_employees_number_B: 0,
        });
      }
      // if (payload.security_team === null || payload.security_team === false) {
      //   setForEdit({ ...payload, security_team_employees_number_B: 0 });
      // }
    }
  }, [isEdit, payload]);

  const handleOfficeSoftware = (value) => {
    setPayload({ ...payload, software_type: value });
    setCurrentQuestion(31);
  };

  const handleCost = (value, id) => {
    setPayload({ ...payload, unavailability_cost: value });
    setCurrentQuestion(id);
  };

  useEffect(() => {
    if (
      showedQuestions.includes(Number(26)) &&
      Object.keys(payload["datacenter_location_C"]).length === 0
    ) {
      setCurrentQuestion(26);
    }
    if (
      showedQuestions.includes(Number(27)) &&
      Object.keys(payload["system_equipments_C"]).length === 0
    ) {
      setCurrentQuestion(27);
    }
    if (
      showedQuestions.includes(Number(2)) &&
      Object.keys(payload["model_A"]).length === 0
    ) {
      setCurrentQuestion(2);
    }

    if (
      showedQuestions.includes(Number(29)) &&
      Object.keys(payload["cloud_providers_C"]).length === 0
    ) {
      setCurrentQuestion(29);
    }

    if (
      showedQuestions.includes(Number(30)) &&
      Object.keys(payload["service_model_C"]).length === 0
    ) {
      setCurrentQuestion(30);
    }
    if (
      showedQuestions.includes(Number(12)) &&
      Object.keys(payload["intellectual_property_E"]).length === 0
    ) {
      setCurrentQuestion(12);
    }
    if (
      showedQuestions.includes(Number(14)) &&
      payload["personal_data_list_E"].length === 0
    ) {
      setCurrentQuestion(14);
    }
    if (
      showedQuestions.includes(Number(15)) &&
      payload["critical_personal_data_list_E"].length === 0
    ) {
      setCurrentQuestion(15);
    }
    if (
      showedQuestions.includes(Number(38)) &&
      payload["WebApp_scopes_F"].length === 0
    ) {
      setCurrentQuestion(38);
    }
    if (
      showedQuestions.includes(Number(41)) &&
      payload["WebApp_Dev_models_F"].length === 0
    ) {
      setCurrentQuestion(41);
    }
    if (
      showedQuestions.includes(Number(42)) &&
      payload["WebApp_Architectures_F"].length === 0
    ) {
      setCurrentQuestion(42);
    }
    if (
      showedQuestions.includes(Number(43)) &&
      payload["WebApp_CMS_F"].length === 0
    ) {
      setCurrentQuestion(43);
    }
    if (
      showedQuestions.includes(Number(44)) &&
      payload["WebApp_programming_F"].length === 0
    ) {
      setCurrentQuestion(44);
    }
  }, [
    payload["datacenter_location_C"],
    payload["system_equipments_C"],
    payload["model_A"],
    payload["cloud_providers_C"],
    payload["service_model_C"],
    payload["intellectual_property_E"],
    payload["personal_data_list_E"],
    payload["critical_personal_data_list_E"],
    payload["WebApp_scopes_F"],
    payload["WebApp_Dev_models_F"],
    payload["WebApp_Architectures_F"],
    payload["WebApp_CMS_F"],
    payload["WebApp_programming_F"],
  ]);

  useEffect(() => {
    if (isEdit) {
      if (payload.datacenter_C === "no") {
        setPayload({
          ...payload,
          datacenter_number_C: null,
          datacenter_location_C: [],
          system_equipments_C: {},
        });
      }
    }
  }, [payload.datacenter_C, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.disruption_level === "no_disruption") {
        setForEdit({
          ...payload,
          unavailability_cost: null,
        });
      }
      if (payload.annualized_frequency.i_dont_know === 1 || payload.annualized_frequency.no_attack === 1) {
        setForEdit({
          ...payload,
          disruption_hours: "",

        });
      }
    }
  }, [payload, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.disruption_level === "no_disruption") {
        setPayload({
          ...payload,
          unavailability_cost: null,
        });
      }
    }
  }, [payload.disruption_level, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.proprety_intellectuel === false) {
        setPayload({
          ...payload,
          intellectual_property_E: [],
        });
      }
    }
  }, [payload.proprety_intellectuel, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.personal_data_E === false) {
        setPayload({
          ...payload,
          personal_data_list_E: [],
          critical_personal_data_list_E: [],
          subcontractors_data_access_E: null,
        });
      }
    }
  }, [payload.personal_data_E, isEdit]);

  useEffect(() => {
    if (payload.WebApp_status_F === false) {
      setPayload({
        ...payload,
        MobileApp_status_F: null,
        WebApp_Architectures_F: [],
        WebApp_CMS_F: [],
        WebApp_Description_F: null,
        WebApp_Dev_entity_F: null,
        WebApp_Dev_models_F: [],
        WebApp_Dev_number_F: null,
        WebApp_IA_status_F: null,
        WebApp_Launch_Date_F: null,
        WebApp_programming_F: [],
        WebApp_scopes_F: [],
        WebApp_age_F: null,
        e_commerce_presence_D: null,
        payment_process_D: null,
      });
      setLatestStepQuestion(35);
      setCurrentQuestion(35);
    }
    if (payload.WebApp_status_F === "in_progress") {
      setPayload({
        ...payload,
        WebApp_Launch_Date_F: null,
        WebApp_age_F: null,
      });
    }
  }, [payload.WebApp_status_F, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.service_delivery_D === false) {
        setPayload({
          ...payload,
          service_delivery_tools_number_D: null,
          Sla_availability_D: null,
          kpi_presence_D: null,
          kpi_support_method_D: null,
          subcontractors_presence_D: null,
        });
      }
    }
  }, [payload.service_delivery_D, isEdit]);

  useEffect(() => {
    if (isEdit) {
      if (payload.cloud_usage_C === false) {
        setPayload({
          ...payload,
          cloud_providers_C: [],
          // apps_daily_use_number_C: 0,
          service_model_C: {},
        });
        // setLatestStepQuestion(29);
        // setCurrentQuestion(29);
      }
    }
  }, [payload.cloud_usage_C, isEdit]);

  useEffect(() => {
    if (payload.e_commerce_presence_D === false) {
      setPayload({ ...payload, payment_process_D: null });
    }
  }, [payload.e_commerce_presence_D]);

  useEffect(() => {
    if (!payload.model_A.includes("B2B")) {
      setPayload({
        ...payload,
        display_clients_number_A_B2B: 0,
      });
    }
    if (!payload.model_A.includes("B2C")) {
      setPayload({
        ...payload,
        display_clients_number_A_B2C: 0,
      });
    }
  }, [payload.model_A, isEdit]);


  const scrollToQuestion = (data, height, value) => {
    const genericNextQuestion = isEdit ? "nextStepQuestion" : "nextQuestion";
    if (!data.conditional) {
      const nextQuestion = data.conditional
        ? data[genericNextQuestion][value]
        : data[genericNextQuestion];
      if (!nextQuestion) {
        setShowedQuestions([...showedQuestions.filter((el) => data.id >= el)]);
        if (isEdit) {
          setLatestStepQuestion(data.id);
        } else {
          setLatestQuestion(data.id);
        }
        setCurrentQuestion(data.id);
        return;
      }
      // if (!showedQuestions.includes(nextQuestion)) {

      if (currentQuestion === data.id) {
        setMinHeight(minHeight + height);
        setCurrentQuestion(nextQuestion);
        setShowedQuestions([...showedQuestions, nextQuestion]);
        // setShowedQuestions([...showedQuestions.filter(el=> data.id >= el), nextQuestion]);
      } else {
        myRefs.current[nextQuestion].current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        setShowedQuestions([...showedQuestions, nextQuestion]);
        // }
      }
    }
  };

  // useEffect(() => {
  //   if (isEdit) {
  //     if (currentQuestion === 31 && payload?.personal_data_E === false) {
  //       setLatestStepQuestion(currentQuestion);
  //     }
  //   }
  // }, [payload?.personal_data_E, isEdit, currentQuestion]);

  useEffect(() => {
    if (currentQuestion === 48) {
      setLatestStepQuestion(48);
    }
  }, [currentQuestion]);

  const handleChangeValue = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubmit = () => {
    const orgaData = {
      ...payload,
      MobileApp_status_F: null,
      WebApp_Architectures_F: [],
      WebApp_CMS_F: [],
      WebApp_Description_F: null,
      WebApp_Dev_entity_F: null,
      WebApp_Dev_models_F: [],
      WebApp_Dev_number_F: null,
      WebApp_IA_status_F: null,
      WebApp_Launch_Date_F: null,
      WebApp_programming_F: [],
      WebApp_status_F: null,
      WebApp_scopes_F: [],
      WebApp_age_F: null,
      e_commerce_presence_D: null,
      payment_process_D: null,
    };
    const obj = { ...payload, organization_data: JSON.stringify(orgaData) };
    const listRemovedKey = globalData
      .filter((el) => !!el.payloadEliminate)
      .map((el) => el.key);
    listRemovedKey.forEach((item) => delete obj[item]);
    dispatch(
      requestCreatingOrganizationProfile(
        { token: "test", answers: obj, tabs_completed: 5 },
        history,
        t,
        accountType
      )
    );
  };

  const handleConfirmEdit = () => {
    const completedTabs = [
      forEdit?.model_A?.length > 0,
      forEdit?.number_of_employees_B > 0,
      forEdit?.service_delivery_D !== (undefined || null),
      forEdit?.personal_data_E !== (undefined || null),
      Object.values(forEdit?.annualized_frequency).some(value => value !== 0),
      forEdit?.office_access !== (undefined || null),
      forEdit?.WebApp_status_F !== (undefined || null),
    ].filter((el) => el === true).length;
    const obj = {
      ...forEdit,
      organization_data: JSON.stringify(forEdit),
      id: profileId,
      tabs_completed: completedTabs,
    };
    const listRemovedKey = globalData
      .filter((el) => !!el.payloadEliminate)
      .map((el) => el.key);
    listRemovedKey.forEach((item) => delete obj[item]);

    dispatch(requestUpdatingOrganizationProfile(profileId, obj, history,isAuth));
  };

  const handleEdit = () => {
    if (pendingQuizzes === "0") {
      handleConfirmEdit();
    } else {
      setOpen(true);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  const handleError = (bol) => {
    setError(bol);
  };
  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width:900px)");
  const [isOpen, setIsOpen] = useState(false);

  const toggleAside = () => setIsOpen((prevIsOpen) => !prevIsOpen);

  const asideRef = useRef();
  useOnClickOutside(asideRef, isMobile && isOpen ? toggleAside : () => null);

  useEffect(() => {
    // return () => {
    if (showedQuestions.includes(42)) {
      setCurrentQuestion(42);
      setShowedQuestions(showedQuestions.filter((el) => !(el > 42)));
    }
    // };
  }, [payload["WebApp_Architectures_F"]]);

  useEffect(() => {
    if (currentQuestion === 42) {
      if (!payload["WebApp_Architectures_F"].includes("CMS")) {
        setShowedQuestions([...showedQuestions.filter((el) => el !== 43)]);
        setPayload({
          ...payload,
          WebApp_CMS_F: [],
        });
      }
      if (
        !payload["WebApp_Architectures_F"].includes("eventdriven") &&
        !payload["WebApp_Architectures_F"].includes("Serverless") &&
        !payload["WebApp_Architectures_F"].includes("Microservice") &&
        !payload["WebApp_Architectures_F"].includes("3tier")
      ) {
        setShowedQuestions([...showedQuestions.filter((el) => el !== 44)]);
        setPayload({
          ...payload,
          WebApp_programming_F: [],
        });
      }
    }

  }, [currentQuestion, payload["WebApp_Architectures_F"]]);

  useEffect(() => {
    if (
      payload["software_type"] === "google_workspace" &&
      showedQuestions.includes(33)
    ) {
      setShowedQuestions([...showedQuestions.filter((el) => el !== 33)]);
    } else if (
      payload["software_type"] === "microsoft_office" &&
      showedQuestions.includes(32)
    ) {
      setShowedQuestions([...showedQuestions.filter((el) => el !== 32)]);
    }
  }, [payload]);

  return (
    <>
      {isMobile && !isOpen && (
        <FormatListNumberedIcon
          onClick={toggleAside}
          style={{
            color: "#26876b",
            position: "fixed",
            top: 32,
            transform: "translateY(-50%)",
            left: 20,
          }}
        />
      )}

      <Grid
        className={`container-shadow ${isMobile && isOpen ? "aside-open" : ""}`}
        container
        justifyContent="space-around"
        width={"100%"}
      >
        <Grid
          ref={asideRef}
          className={`profile-organization-aside ${isMobile ? "mobile" : ""} ${isOpen ? "open" : ""
            }`}
          item
          xs={4}
          sx={{
            width: "100%",
            borderRight: "1px solid rgba(0, 0, 0, 0.3)",
            padding: "10px",
            alignItems: "center",
          }}
        >
          {isAuth && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={goBack}>
                <KeyboardBackspaceIcon />
              </IconButton>
              <span className="return-button">{t("back_to_dashboard")}</span>
            </div>
          )}

          <br />
          <div style={{ padding: "15px" }}>
            <Typography variant="title">
              {t("organization_profile_steps")}
            </Typography>
          </div>

          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              padding: "10px",
            }}
          >
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChangeValue}
              aria-label="Vertical tabs example"
              sx={{
                alignItems: "start",
                borderLeft: 2,
                borderColor: "divider",
                mt: 5,
                ".MuiTabs-indicator": {
                  left: 0,
                  backgroundColor: "#0FB694",
                  alignItems: "start",
                },
                ".MuiButtonBase-root": {
                  alignItems: "start",
                  color: "black",
                  textAlign: "left",
                },
                ".Mui-selected": {
                  color: "#0FB694 !important",
                },
              }}
            >
              <Tab
                label={`${t("step")} 1: ${t("organizations_identity")}`}
                onClick={() => {
                  scrollToStep(0);
                }}
                // sx={{ mb: 5 }}
                {...a11yProps(0)}
                disabled={!steps?.includes(1)}
              />
              <Tab
                label={`${t("step")} 2: ${t("organizational_structure")}`}
                onClick={() => {
                  scrollToStep(5);
                }}
                disabled={
                  Math.max(...showedQuestions) < 5 || !steps?.includes(2)
                }
                sx={{ mt: 3 }}
                {...a11yProps(1)}
              />

              <Tab
                label={`${t("step")} 3: ${t("service_delivery")}`}
                onClick={() => {
                  scrollToStep(9);
                }}
                disabled={
                  Math.max(...showedQuestions) < 9 || !steps?.includes(3)
                }
                sx={{ mt: 3 }}
                {...a11yProps(2)}
              />
              <Tab
                label={`${t("step")} 4: ${t("organizations_data")}`}
                onClick={() => {
                  scrollToStep(12);
                }}
                disabled={
                  Math.max(...showedQuestions) < 12 || !steps?.includes(4)
                }
                sx={{ mt: 3 }}
                {...a11yProps(3)}
              />
              <Tab
                label={`${t("step")} 5: ${t("security_incident")}`}
                onClick={() => {
                  scrollToStep(17);
                }}
                disabled={
                  Math.max(...showedQuestions) < 18 || !steps?.includes(5)
                }
                sx={{ mt: 3 }}
                {...a11yProps(4)}
              />
              <Tab
                label={`${t("step")} 6: ${t("it_system")}`}
                onClick={() => {
                  scrollToStep(36);
                }}
                disabled={
                  Math.max(...showedQuestions) < 23 || !steps?.includes(6)
                }
                sx={{ mt: 3 }}
                {...a11yProps(5)}
              />

              {isEdit && (
                <Tab
                  label={`${t("step")} 7: ${t("step_6")}`}
                  onClick={() => {
                    scrollToStep(35);
                  }}
                  disabled={
                    Math.max(...showedQuestions) < 36 || !steps?.includes(7)
                  }
                  sx={{ mt: 3 }}
                  {...a11yProps(6)}
                />
              )}
            </Tabs>
          </Box>
        </Grid>
        <Grid
          item
          xs={isMobile ? 12 : 8}
          sx={{
            flexGrow: 1,
            overflow: "auto",
            maxWidth: "100%",
          }}
        >
          <div
            style={{
              padding: "10px",
              overflow: "auto",
              height: !isAuth ? "calc(100vh - 84px)" : "calc(100vh - 20px)",
            }}
          >
            <div style={{ padding: "30px", textAlign: "center" }}>
              <div style={{ width: "100%", margin: "auto", padding: "50 px" }}>
                <Typography variant="subtitle1" sx={{ fontSize: "30px" }}>
                  {" "}
                  {t("profile_organization_title")}
                </Typography>
                <p style={{ width: "100%" }}>
                  {t("profile_organization_description")}
                </p>
              </div>
            </div>

            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={9} minHeight={minHeight}>
                {globalData.map((el, i) => (
                  <div key={i}>
                    {(() => {
                      switch (el.type) {
                        case "textField":
                          return (
                            showedQuestions.includes(el.id) && (
                              <OrganizationNameQuestion
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                profileNames={profileNames}
                                handleDisabled={handleError}
                                value={payload[el.key]}
                              />
                            )
                          );
                        case "slider":
                          return (
                            showedQuestions.includes(el.id) && (
                              <LinearSliderQuestion
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                value={payload[el.key]}
                              />
                            )
                          );
                        case "radio":
                          return (
                            showedQuestions.includes(el.id) && (
                              <RadioQuestion
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                handleCurrentQuestion={(id) =>
                                  setCurrentQuestion(id)
                                }
                                data={el}
                                value={payload[el.key]}
                                handleOfficeSoftware={handleOfficeSoftware}
                                handelRequiredQuestion={handelRequiredQuestion}
                              />
                            )
                          );
                        case "inputRadio":
                          return (
                            showedQuestions.includes(el.id) && (
                              <InputRadio
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                handleCurrentQuestion={(id) =>
                                  setCurrentQuestion(id)
                                }
                                data={el}
                                value={payload[el.key]}
                                handleCost={handleCost}
                                handelRequiredQuestion={handelRequiredQuestion}
                              />
                            )
                          );
                        case "checkbox":
                          return (
                            showedQuestions.includes(el.id) && (
                              <MultiSelect
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                payload={payload}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                showedQuestions={showedQuestions}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                myAnswer={payload[el.key]}
                              />
                            )
                          );
                        case "checkboxInput":
                          return (
                            showedQuestions.includes(el.id) && (
                              <MultiSelectInput
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                payload={payload}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                showedQuestions={showedQuestions}
                                handleCurrentQuestion={(id) =>
                                  setCurrentQuestion(id)
                                }
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                myAnswer={payload[el.key]}
                              />
                            )
                          );
                        case "card":
                          return (
                            showedQuestions.includes(el.id) && (
                              <CardQuestion
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                handleCurrentQuestion={(id) =>
                                  setCurrentQuestion(id)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                              />
                            )
                          );
                        case "autocomplete":
                          return (
                            showedQuestions.includes(el.id) && (
                              <SelectCountry
                                  handleEdit={handleEdit}
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                show={showedQuestions.includes(el.id)}
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                value={payload[el.key]}
                              />
                            )
                          );
                        case "multiTags":
                          return (
                            showedQuestions.includes(el.id) && (
                              <MultiTags
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                show={showedQuestions.includes(el.id)}
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                choises={
                                  el.getPersistData
                                    ? stockedDataApp
                                    : el.choises
                                }
                                setPersistedData={(data) =>
                                  setStockedDataApp(data)
                                }
                                data={el}
                                value={payload[el.key]}
                                jsonData={jsonData}
                                payload={payload}
                              />
                            )
                          );
                        case "nonLinear":
                          return (
                            showedQuestions.includes(el.id) && (
                              <NonLinear
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                nonLinearValue={payload[el.key]}
                                payload={payload}
                                steps={steps}
                                handelRequiredQuestion={handelRequiredQuestion}
                                requiredQuestion={requiredQuestion}
                              />
                            )
                          );
                        case "conditionalMultiSelect":
                          return (
                            showedQuestions.includes(el.id) && (
                              <ConditionalMultiSelect
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayloadB2C={(data, value) =>
                                  handlePayloadB2C(data, value)
                                }
                                handlePayloadB2B={(data, value) =>
                                  handlePayloadB2B(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                nonLinearValueB2B={payload[el.keyB2B]}
                                nonLinearValueB2C={payload[el.keyB2C]}
                                payload={payload}
                              />
                            )
                          );

                        case "date":
                          return (
                            showedQuestions.includes(el.id) && (
                              <WebAppDate
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                show={showedQuestions.includes(el.id)}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                // profileNames={profileNames}
                                handleDisabled={handleError}
                                value={payload[el.key]}
                              />
                            )
                          );
                        case "input":
                          return (
                            showedQuestions.includes(el.id) && (
                              <InputField
                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                value={payload[el.key]}
                              />
                            )
                          );
                        case "inputField":
                          return (
                            showedQuestions.includes(el.id) && (
                              <InputNumberQuestion

                                isEdit={isEdit}
                                latestStepQuestion={latestStepQuestion}
                                latestQuestion={latestQuestion}
                                currentQuestion={currentQuestion}
                                handlePayload={(data, value) =>
                                  handlePayload(data, value)
                                }
                                handlePayloadB2C={(data, value) =>
                                  handlePayloadB2C(data, value)
                                }
                                handlePayloadB2B={(data, value) =>
                                  handlePayloadB2B(data, value)
                                }
                                scrollToQuestion={(id, height, value) =>
                                  scrollToQuestion(id, height, value)
                                }
                                ref={myRefs.current[el.id]}
                                data={el}
                                value={payload[el.key]}
                                payload={payload}
                                nonLinearValueB2B={payload[el.keyB2B]}
                                nonLinearValueB2C={payload[el.keyB2C]}

                              />
                            )
                          );
                        default:
                          return null;
                      }
                    })()}
                  </div>
                ))}

                {!isEdit && currentQuestion === latestQuestion && (
                  <div style={{ padding: "0 20px" }}>
                    <Button
                      onClick={handleSubmit}
                      style={{ height: "50px" }}
                      color="secondary"
                      variant="contained"
                      disabled={error}
                      fullWidth
                    >
                      {t("submit")}
                    </Button>
                  </div>
                )}
                {isEdit && currentQuestion === latestStepQuestion && (
                  <div style={{ padding: "0 20px" }}>
                    <Button
                      onClick={handleEdit}
                      style={{ height: "50px" }}
                      color="secondary"
                      variant="contained"
                      // disabled={error}
                      fullWidth
                    >
                      {t("validate")}
                    </Button>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <ControlEditOrgaProfile
        open={open}
        handleClose={handleClose}
        handleConfirmEdit={handleConfirmEdit}
        isMobile={isMobile}
      />
    </>
  );
};

export default ProfileOrganization;
